export default {
  leavePage: {
    en: 'Are you sure you want to leave this page? Your review will not be saved.',
  },
  closeModal: {
    en: 'Are you sure? Your changes will be lost.',
  },
}
